import * as React from "react";
import { Button, FormGroup, Input, Label, Modal } from "../components/Modal";

interface AddDelegationModalProps {
    isOpen: boolean;
    query: string;
    results: any[];
    selectedUser: any;
    rules: string;
    onQueryChange: (query: string) => void;
    onSelectUser: (user: any) => void;
    onRulesChange: (rules: string) => void;
    onClose: () => void;
    onAdd: () => void;
}

export const AddDelegationModal = ({ isOpen, query, results, selectedUser, rules, onQueryChange, onSelectUser, onRulesChange, onClose, onAdd }: AddDelegationModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Delegated Access" icon={["fad", "user-plus"]} iconColor="text-green-600">
        <div className="p-6 space-y-4">
            <FormGroup>
                <Label>Find a delegate</Label>
                <Input type="search" value={query} onChange={(event: any) => onQueryChange(event.target.value)} placeholder="Enter at least 3 characters" />
            </FormGroup>
            {results.length > 0 && !selectedUser && <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-md divide-y divide-gray-200">
                {results.map((user) => <button key={user.id} type="button" onClick={() => onSelectUser(user)} className="block w-full p-3 text-left hover:bg-gray-50"><span className="block text-sm font-medium">{user.fullName || `${user.firstName} ${user.lastName}`}</span><span className="block text-xs text-gray-500">{user.email}</span></button>)}
            </div>}
            {selectedUser && <div className="rounded-md bg-green-50 border border-green-200 p-3 text-sm text-green-800">Delegate: <b>{selectedUser.fullName || selectedUser.email}</b></div>}
            <FormGroup><Label>Delegation rules (optional)</Label><Input type="textarea" rows={3} value={rules} onChange={(event: any) => onRulesChange(event.target.value)} /></FormGroup>
        </div>
        <div className="border-t border-gray-200 bg-gray-50 px-6 py-4 flex justify-end gap-3"><Button variant="secondary" onClick={onClose}>Cancel</Button><Button disabled={!selectedUser} onClick={onAdd}>Add delegation</Button></div>
    </Modal>
);
